exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ic-store {\n  position: relative;\n}\n.ic-store__row {\n  display: -ms-flexbox;\n  display: flex;\n}\n.ic-store__name {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  min-width: 0;\n  font-weight: 500;\n  color: #526069;\n}\n.ic-store__status {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  color: #ff666b;\n  padding-top: 1px;\n  font-size: 12px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.ic-store__show {\n  color: #589ffc;\n}\n.ic-store__type {\n  color: #76838f;\n  font-size: 13px;\n  font-weight: 400;\n  padding-top: 3px;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n.ic-store__data-title {\n  font-weight: 400;\n  color: #526069;\n}\n.ic-customer__data-time{\n  color: #8095D0;\n  font-weight: 300;\n  font-size: 12px;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\nagm-map {\n  height: 300px;\n}\n\n.ic-row-block{\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  padding-right: 10px;\n}\n\n.ic-row-label {\n  width: 150px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0\n}\n\n.ic-row-content {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/store_manager/store-sale/store-sale.component.css
// module id = ../../../../../src/app/pages/admin/evs/store_manager/store-sale/store-sale.component.css
// module chunks = 3